import { render } from "./TopicComponent.vue?vue&type=template&id=723e7312&scoped=true"
import script from "./TopicComponent.vue?vue&type=script&lang=js"
export * from "./TopicComponent.vue?vue&type=script&lang=js"

import "./TopicComponent.vue?vue&type=style&index=0&id=723e7312&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723e7312"]])

export default __exports__